@if (content) {
<div class="w-12 flex">
    <div class="w-6 pos-relative"
         *ifSize="'XL'">
        @if(content.image) {
        <img class="w-12"
             [ratio]="1"
             [dfImage]="content.image">
        }
    </div>
    <div class="w-6 w-12-m w-12-s center overflow-hidden overflow-y-auto _vh-fix"
         id="login-view-layout-scroll">
        <div class="w-8 w-12-m w-12-s m-b-0 p-t-10 p-t-0-m p-t-0-s p-r-5 p-r-0-m p-r-0-s p-b-10 left"
             [ngClass]="content.mobileImage && (client.isS || client.isM) ? '' : 'm-t-5 m-t-3-m m-t-3-s'">
            <ng-container *ngTemplateOutlet="template; context: { $implicit: content }">
            </ng-container>
        </div>
    </div>
</div>
}